import MuiAlert, { AlertProps } from '@mui/material/Alert'
import React from 'react'

function AlertDefault({
  ref,
  ...props
}: AlertProps & { ref?: React.Ref<HTMLDivElement> }) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
}

export default AlertDefault
